<template>
  <div class="d-flex justify-center">
    <v-dialog v-model="localOpen" max-width="800">
      <v-card>
        <v-card-title class="text-h5 error text-white">
          Delete product
        </v-card-title>

        <v-card-text>
          <div class="text-h6" style="line-height: 1.4 !important">
            <p class="mt-2 mb-3">
              Do you really want to delete product
              <strong>
                "{{
                  campaignProduct.product
                    ? campaignProduct.product_name
                    : campaignProduct.id
                }}"?
              </strong>
              This operation can't be undone.
            </p>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-3 px-3">
          <v-spacer></v-spacer>
          <v-btn
            variant="outlined"
            color="error"
            @click="localOpen = false"
          >
            cancel
          </v-btn>
          <v-btn
            :loading="deleting"
            :disabled="deleting"
            color="error"
            @click="$emit('confirm-delete', campaignProduct)"
          >
            Delete
            <template v-slot:loader>
              <span>Saving...</span>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    open: { type: Boolean, default: false },
    campaignProduct: { type: Object, default: () => ({}) },
    deleting: { type: Boolean, default: false },
  },

  emits: ['update:open', 'confirm-delete'],

  computed: {
    localOpen: {
      get() { return this.open; },
      set(val) { this.$emit('update:open', val); },
    },
  },
};
</script>
